<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--lg">

                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-flask-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                                <p class="cf-modal-head__sub">Double-cliquez sur une matière première pour la sélectionner</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <div class="cf-dialog-toolbar">
                        <div class="search-wrap">
                            <i class="ri-search-line search-icon"></i>
                            <input v-model="searchword" ref="modalInput" type="text" class="search-input" placeholder="Rechercher une matière première..." />
                            <button v-if="searchword" @click="searchword = ''" class="search-clear"><i class="ri-close-circle-fill"></i></button>
                        </div>
                    </div>

                    <div class="cf-dialog-body cf-dialog-body--flush">
                        <div class="table-scroll-wrap art-scroll">
                            <table class="art-table">
                                <thead class="table-head">
                                <tr>
                                    <th class="th th--center" style="width:60px;">N°</th>
                                    <th class="th">Article (Matière première)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-if="filterdatatable.length">
                                    <tr @dblclick="selected(datavalue)" class="table-row cf-row-clickable" v-for="(datavalue, index) in filterdatatable" :key="index">
                                        <td class="td td--center"><span class="row-number">{{ index + 1 }}</span></td>
                                        <td class="td"><span style="font-weight:500;color:var(--cf-ink-strong);">{{ datavalue.libelle }}</span></td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="20">
                                            <div class="empty-state">
                                                <div class="empty-state__icon"><i class="ri-inbox-line"></i></div>
                                                <p class="empty-state__title">Aucun enregistrement</p>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="cf-dialog-foot cf-dialog-foot--split">
                        <nav v-if="pages.length > 1" class="pagination">
                            <button @click="page--" :disabled="page <= 1" class="page-btn page-btn--nav"><i class="ri-arrow-left-s-line"></i></button>
                            <template v-for="(pageNumber, key) in displayedPages" :key="key">
                                <span v-if="pageNumber === '...'" style="padding:0 4px;color:var(--cf-faint);font-size:13px;">…</span>
                                <button v-else @click="page = pageNumber" :class="['page-btn', pageNumber === page ? 'page-btn--active' : 'page-btn--default']">{{ pageNumber }}</button>
                            </template>
                            <button @click="page++" :disabled="page >= pages.length" class="page-btn page-btn--nav"><i class="ri-arrow-right-s-line"></i></button>
                        </nav>
                        <span v-else></span>
                        <div style="display:flex;align-items:center;gap:0.6rem;">
                            <button @click="selected(null)" type="button" class="ds-btn-ghost"><i class="ri-eraser-line"></i> Effacer la sélection</button>
                            <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                        </div>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>
    import {cloneobjet} from "@/allfunction";
    //import * as JwtService from "@/common/jwt.service";
     import {mapGetters} from "vuex";

    //const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },
            DefaultperPage: function(newvalue,oldvalue){

                this.page=1

            },



        },
        computed:{

            ...mapGetters(['listedesarticles']),
            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable





                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;


                mvalue = mvalue.filter( function (post) {
                    return    post.typearticle.toLowerCase().includes("matierspremiere".toLowerCase())

                })

                if (this.searchword!==''){
                    let t=this;


                    mvalue = mvalue.filter( function (post) {
                        return    post.libelle.toLowerCase().includes(t.searchword.toLowerCase())

                    })

                }

                this.allItems = mvalue.length;



                return this.paginate(mvalue) ;
            },
        },
        components: {
            //modalform

        },

        data() {
            return {
                isdisplay:false,
                titlemodal:"",
                datatable:[],
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                btnaction:"",
                pidmag:"",





                searchword:"",
                searchtrierletableau:"",


                allItems:0,
                lastkey:0,
                paginationpage:1,
                nextPage:1,
                countItems:1,
                countPageItems:0,



                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 500,
                Defaultpage: 1,
                DefaultperPage: 500,
                pages: [],
            };
        },
        methods: {

            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },

            async selected(datavalue){

/*
                const t = this;
                let url=`${process.env.VUE_APP_API_URL}/egl745874pstock771714dfe/ar/${datavalue.pid}/${datavalue.pidmag}/majstck/${this.$store.state.appsociete}/${randomString()}`;
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){

                            datavalue.rstck=res.data.m.stck;


                        }




                        // Suppose que vous avez un objet représentant l'élément sélectionné
                        const elementSelectionne = { typ: t.btnaction, value: datavalue,
                            datatable:[]};

                        // Émettre un événement personnalisé avec l'élément sélectionné
                        t.$emit('elementSelectionnearticle', elementSelectionne);

                        // Fermer le modal ou effectuer d'autres actions nécessaires
                        t.isdisplay=false;


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })

                */

                let elementSelectionne


                // Suppose que vous avez un objet représentant l'élément sélectionné
                if (datavalue!==null){

                    elementSelectionne = { typ:'', value: {pid:datavalue.pid,libelle:datavalue.libelle,unite:datavalue.unite},
                        datatable:[]};

                }else{

                    elementSelectionne = { typ:'', value: {pid:"",libelle:"",unite:""},
                        datatable:[]};

                }


                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('elementSelectionnearticle', elementSelectionne);

                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;




            },


            show(titlemodal,btnaction,listdata,pidmag){
                this.messagesucces="";
                this.messageerror="";
                this.searchword="";
                this.titlemodal=titlemodal
                this.datatable=listdata
                this.pidmag=pidmag


                this.$store.dispatch('loadlistedesarticles')


                let datamvalue=cloneobjet(this.listedesarticles),
                    searchKey=this.pidmag.toString().toLowerCase()

                this.datatable= datamvalue.filter(item => item.jsonarticles.some(subItem => subItem.mg.pid.toString().toLowerCase() === searchKey));



                this.isdisplay=true;

               // this.$refs.modalInput.focus();

            },



            async loadtrt(){

                this.$store.dispatch('resetloadlistedesarticles')
            },





            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--lg { max-width:720px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-toolbar { padding:0.75rem 1rem; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-body--flush { padding:0; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-foot--split { justify-content:space-between; }

.search-wrap { position:relative; max-width:400px; }
.search-icon { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:var(--cf-faint); }
.search-input { width:100%; padding:9px 34px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); font-size:0.82rem; color:var(--cf-ink); outline:none; transition:border-color 0.2s; }
.search-input:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.search-clear { position:absolute; right:8px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:var(--cf-faint); }

.table-scroll-wrap { overflow:auto; }
.art-scroll { max-height:52vh; }
.art-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; min-width:420px; }
.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--center { text-align:center; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.cf-row-clickable { cursor:pointer; }
.td { padding:0.65rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; white-space:nowrap; }
.td--center { text-align:center; }
.row-number { color:var(--cf-faint); font-size:0.75rem; font-variant-numeric:tabular-nums; }

.empty-state { padding:2.5rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:14px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }

.pagination { display:flex; align-items:center; gap:4px; }
.page-btn { min-width:30px; height:30px; padding:0 8px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); background:#fff; color:var(--cf-ink); font-size:0.78rem; font-weight:600; cursor:pointer; transition:all 0.15s; }
.page-btn:hover:not(:disabled) { border-color:rgb(var(--primary) / 0.35); background:var(--cf-surface); }
.page-btn:disabled { opacity:0.5; cursor:not-allowed; }
.page-btn--active { background:rgb(var(--primary)); border-color:rgb(var(--primary)); color:#fff; }
.page-btn--nav { width:34px; display:inline-flex; align-items:center; justify-content:center; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

.art-scroll::-webkit-scrollbar { width:6px; height:6px; }
.art-scroll::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:3px; }

@media (max-width:768px) { .cf-dialog--lg { max-width:100%; } .art-scroll { max-height:65vh; } }
</style>
